document.addEventListener('DOMContentLoaded', function() {
    // Get adventure popup elements
    const adventureClosePopupBtn = document.getElementById('adventureClosePopupBtn');
    const adventurePopupOverlay = document.getElementById('adventurePopupOverlay');
    const adventureForm = document.getElementById('adventureForm');
    
    // Google Apps Script Web App URL - Replace with your actual deployed web app URL
    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxx7WkOvZS8elTno34nr-6KO1NNDltPVfP_N_ov4kyF_KoJOWo3FmZU9soddBViYWaT/exec';
    
    // CRITICAL: Force hide popup on ALL pages by default
    if (adventurePopupOverlay) {
        adventurePopupOverlay.classList.remove('adventure-active');
        adventurePopupOverlay.style.display = 'none';
        adventurePopupOverlay.style.opacity = '0';
        adventurePopupOverlay.style.visibility = 'hidden';
        adventurePopupOverlay.style.pointerEvents = 'none';
    }
    
    // Handle all buttons that can open the popup (supports multiple buttons across different pages)
    const allOpenButtons = document.querySelectorAll('[data-product]');
    console.log('Found buttons with data-product:', allOpenButtons.length);
    
    // Only add event listeners if buttons exist on this page
    if (allOpenButtons.length > 0) {
        allOpenButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault(); // Prevent any default behavior
                e.stopPropagation(); // Stop event bubbling
                
                // Get the product value from the clicked button
                const productValue = this.getAttribute('data-product');
                console.log('Button clicked, product value:', productValue);
                
                // Get variant data from button attributes
                const variant1 = this.getAttribute('data-variant1');
                const variant2 = this.getAttribute('data-variant2');
                const variant3 = this.getAttribute('data-variant3');
                const variant4 = this.getAttribute('data-variant4');
                const variant5 = this.getAttribute('data-variant5');
                const variants = [variant1, variant2, variant3, variant4, variant5].filter(v => v && v.trim() !== '');
                console.log('Available variants:', variants);
                
                // Only proceed if popup overlay exists
                if (!adventurePopupOverlay) {
                    console.error('Popup overlay not found!');
                    return;
                }
                
                // Find the hidden field and variant select
                const hiddenProductField = adventureForm ? adventureForm.querySelector('input[name="product"]') : null;
                const variantSelect = adventureForm ? adventureForm.querySelector('select[name="variant"]') : null;
                
                // Set the hidden field value to product title only
                if (hiddenProductField) {
                    hiddenProductField.value = productValue;
                    console.log('Hidden field value set to:', hiddenProductField.value);
                } else {
                    console.error('Hidden product field not found!');
                }
                
                // Populate variant dropdown
                if (variantSelect) {
                    // Clear existing options
                    variantSelect.innerHTML = '<option value="">Choose a variant...</option>';
                    
                    // Add variant options
                    variants.forEach(variant => {
                        const option = document.createElement('option');
                        option.value = variant;
                        option.textContent = variant;
                        variantSelect.appendChild(option);
                    });
                    
                    console.log('Variant dropdown populated with:', variants);
                } else {
                    console.error('Variant select field not found!');
                }
                
                // Show the popup with multiple methods to ensure it works
                adventurePopupOverlay.style.display = 'flex';
                adventurePopupOverlay.style.opacity = '1';
                adventurePopupOverlay.style.visibility = 'visible';
                adventurePopupOverlay.style.pointerEvents = 'auto';
                
                // Add active class after a small delay to trigger animations
                setTimeout(() => {
                    adventurePopupOverlay.classList.add('adventure-active');
                }, 10);
                
                // Prevent background scrolling
                document.body.style.overflow = 'hidden';
            });
        });
    }
    
    // Close adventure popup function
    function closeAdventurePopup() {
        if (adventurePopupOverlay) {
            adventurePopupOverlay.classList.remove('adventure-active');
            
            // Wait for transition to complete before fully hiding
            setTimeout(() => {
                adventurePopupOverlay.style.display = 'none';
                adventurePopupOverlay.style.opacity = '0';
                adventurePopupOverlay.style.visibility = 'hidden';
                adventurePopupOverlay.style.pointerEvents = 'none';
            }, 300);
        }
        
        // Restore scrolling
        document.body.style.overflow = 'auto';
        
        // Reset form when closing
        if (adventureForm) {
            adventureForm.reset();
        }
    }
    
    // Close adventure popup on close button click
    if (adventureClosePopupBtn) {
        adventureClosePopupBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            closeAdventurePopup();
        });
    }
    
    // Close adventure popup on overlay click (outside the form)
    if (adventurePopupOverlay) {
        adventurePopupOverlay.addEventListener('click', function(e) {
            if (e.target === adventurePopupOverlay) {
                closeAdventurePopup();
            }
        });
    }
    
    // Close adventure popup on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && adventurePopupOverlay && adventurePopupOverlay.classList.contains('adventure-active')) {
            closeAdventurePopup();
        }
    });
    
    // Adventure form submission handling with Google Sheets integration
    if (adventureForm) {
        adventureForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // Get form data
            const formData = new FormData(adventureForm);
            const data = {
                fullName: formData.get('fullName'),
                email: formData.get('email'),
                mobile: formData.get('mobile'),
                kidName: formData.get('kidName'),
                product: formData.get('product'),
                variant: formData.get('variant')
            };
            
            // Debug: Log all form data
            console.log('Form submission data:', data);
            
            // Basic validation
            if (!data.fullName || !data.email || !data.mobile || !data.kidName || !data.variant) {
                alert('Please fill in all fields including variant selection');
                return;
            }
            
            // Email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(data.email)) {
                alert('Please enter a valid email address');
                return;
            }
            
            // Get submit button and show loading state
            const submitBtn = adventureForm.querySelector('.adventure-join-btn');
            const originalText = submitBtn.textContent;
            submitBtn.textContent = 'Joining... ✨';
            submitBtn.disabled = true;
            
            // Prepare data for Google Sheets - combine product with variant
            const productWithVariant = `${data.product} - ${data.variant}`;
            const googleSheetsData = new FormData();
            googleSheetsData.append('name', data.fullName);
            googleSheetsData.append('email', data.email);
            googleSheetsData.append('phone', data.mobile);
            googleSheetsData.append('kidName', data.kidName);
            googleSheetsData.append('product', productWithVariant);
            
            // Submit to Google Sheets
            fetch(GOOGLE_SCRIPT_URL, {
                method: 'POST',
                body: googleSheetsData
            })
            .then(response => response.text())
            .then(result => {
                console.log('Google Sheets Response:', result);
                
                // Reset button
                submitBtn.textContent = originalText;
                submitBtn.disabled = false;
                
                // Close popup
                closeAdventurePopup();
                
                // Redirect to thank you page
                window.location.href = 'https://www.rabitat.com/pages/thank-you-1';
            })
            .catch(error => {
                console.error('Error submitting to Google Sheets:', error);
                
                // Reset button
                submitBtn.textContent = originalText;
                submitBtn.disabled = false;
                
                // Show error message but still redirect (fallback)
                alert('Thank you for joining! Your information has been received.');
                closeAdventurePopup();
                window.location.href = 'https://www.rabitat.com/pages/thank-you-1';
            });
        });
    }
    
    // Add interactive effects to adventure form inputs (only if they exist)
    const adventureInputs = document.querySelectorAll('.adventure-form-group input');
    adventureInputs.forEach(input => {
        input.addEventListener('focus', function() {
            this.parentElement.classList.add('adventure-focused');
        });
        
        input.addEventListener('blur', function() {
            this.parentElement.classList.remove('adventure-focused');
        });
    });
    
    // Add floating animation to buttons (only if they exist on this page)
    if (allOpenButtons.length > 0) {
        allOpenButtons.forEach(button => {
            setInterval(() => {
                button.style.transform = 'translateY(-2px)';
                setTimeout(() => {
                    button.style.transform = 'translateY(0)';
                }, 1000);
            }, 3000);
        });
    }
});
